module.exports = __webpack_public_path__ + "img/DragonFlyIdle_512.18a20268.gif";